import { Box, Button, Stack, Text } from '@citibox-panel/ui';
import type { DeliveryActionState } from '../model/deliveryActionFlow';

export interface BoxMarksConfirmPanelProps {
  // Its OWN flow instance: `action` here is either null or 'clearBoxMarks'.
  state: DeliveryActionState;
  // The level about to be cleared — named in the sentence so the agent confirms a quantity, not a verb.
  mark: number;
  onCancel: () => void;
  onConfirm: () => void;
}

// TODO: i18n — copy en ES hasta Fase 1.
const CANCEL = 'Cancelar';
const CONFIRM = 'Confirmar';

// The confirm step of the marks clear, and ONLY that: the trigger lives in the banner's alert action
// slot. Keeping the two apart is what puts these controls OUTSIDE the alert — MUI's Alert is an
// assertive live region, so every phase change would be announced over whatever the agent is doing.
// Here the sentence sits in a polite `status`, the way the sequence confirmation does.
//
// Rendered below the banner rather than replacing it, so the level stays on screen while it is being
// confirmed: an agent must never confirm a quantity the UI has just hidden.
export function BoxMarksConfirmPanel({
  state,
  mark,
  onCancel,
  onConfirm,
}: BoxMarksConfirmPanelProps) {
  const { phase } = state;
  if (phase !== 'confirming' && phase !== 'pending') return null;
  const pending = phase === 'pending';
  return (
    <Box
      sx={{
        border: 1,
        borderColor: 'divider',
        borderRadius: 2,
        bgcolor: 'background.default',
        p: 1.5,
        mt: 1,
      }}
    >
      <Stack spacing={1}>
        {/* A status, not a label: it names the quantity being committed. */}
        <Box role="status">
          <Text variant="body2" component="p">
            Se limpiarán las {mark} marcas del buzón. Confírmalo solo si la cerradura ya se ha
            abierto con un código de reset.
          </Text>
        </Box>
        <Stack direction="row" spacing={1} sx={{ justifyContent: 'flex-end' }}>
          <Button variant="text" onClick={onCancel} disabled={pending}>
            {CANCEL}
          </Button>
          {/* The panel replaced the trigger the agent just pressed, so focus has to land somewhere
              deliberate. Mount-only — a re-focus on every render would fight an agent who tabbed. */}
          <Button autoFocus variant="contained" loading={pending} onClick={onConfirm}>
            {CONFIRM}
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
}
